import React, { useRef, useState } from "react";
import date from "date-and-time";
import Flatpickr from "react-flatpickr";

import { CalendarIcon } from "components/Icons";
import useLangStore from "store/langStore";
import { es } from "i18n/calendar_es";
import "flatpickr/dist/themes/airbnb.css";

import FormField from "./FormField";
import { classNames, colors } from "tools/ui";
import upStore from "store/upStore";

const fmt = "YYYY-MM-DD";

function DateField(props) {
  const { locale } = useLangStore();
  const { field, attrs, data } = props;
  const { name, readOnly } = field;
  const { level, minDate = false } = attrs;
  const maxDate =
    typeof field.maxDate === "function" ? field.maxDate(attrs.record) : field.maxDate;
  const fp = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  let initialDate = "";
  if (data.value) {
    if (typeof data.value.getMonth === "function") {
      initialDate = date.format(data.value, fmt);
    } else {
      initialDate = data.value;
    }
  }

  function openCalendar() {
    if (isOpen) {
      fp.current.flatpickr.close();
    } else {
      fp.current.flatpickr.open();
    }
  }
  const options = { disableMobile: true };
  if (minDate) {
    options.minDate = minDate;
    options.dateFormat = "Y-m-d";
  }
  if (maxDate) {
    options.maxDate = maxDate;
    options.dateFormat = "Y-m-d";
  }

  if (locale === "es") {
    options.locale = es;
  }

  function handleClose() {
    setIsOpen(false);
  }

  function handleDate(rangeDates) {
    if (rangeDates.length === 0) return;
    const _value = rangeDates[0];
    if (maxDate) {
      const _max = new Date(maxDate);
      if (_value.getTime() > _max.getTime()) return;
    }
    const value = date.format(_value, fmt);
    data.value = value;
    upStore(level, {
      fieldName: name,
      value: value,
      field: field,
    });
    if (field.onChange) {
      field.onChange(props.name, value);
    }
  }

  let color = "bg-white";
  if (readOnly) {
    color = colors.readOnly;
  }

  const style = "flatpickr outline-none w-full py-2 px-2 rounded-md wrap";
  const styleIcon =
    "text-start mr-2 h-6 w-6 my-auto text-neutral-500 cursor-pointer max-md:hidden";
  const styleDiv =
    "flex outline-none border border-slate-300 rounded-md focus:border-sky-400 h-10 fill-current";

  return (
    <FormField {...field}>
      <div id="div-flatpickr" className={classNames(styleDiv, color)}>
        <Flatpickr
          ref={fp}
          className={classNames(style, color)}
          value={initialDate}
          onChange={handleDate}
          onClick={openCalendar}
          onClose={handleClose}
          options={options}
          disabled={readOnly}
        />
        <CalendarIcon
          onClick={openCalendar}
          className={classNames(styleIcon, color)}
          aria-hidden="true"
          disabled={readOnly}
        />
      </div>
    </FormField>
  );
}

export default DateField;
